export default __webpack_public_path__ + "static/media/customer-1.75582684.svg";